import { RestResponse } from "@/business/shared/commons/rest/RestResponse";
import { restClient } from "@/business/shared/commons/rest/restClient";
import { getAllGuestsUrl } from "../constants/urls";
import { getEnvVariable } from "@/business/shared/commons/envUtils/getEnvVariable";
import { ClientEvent, EventActions, Guest } from "../../domain/events";
import { DaccachErrorActions } from "@/business/shared/commons/DaccachError";

export const getAllGuestsService = {
  async execute(token: string): Promise<ClientEvent[]> {
    const url = getEnvVariable
      .execute("VUE_APP_DACCACH_URL")
      .concat(getAllGuestsUrl);

    const headers = {
      "web-token": token,
      Accept: "application/json",
      "Content-Type": "application/json",
    };

    const response: RestResponse = await restClient().sendRequest(
      url,
      "GET",
      null,
      headers
    );

    if (response.statusCode == 204) return [];

    if (!response.isSuccess) {
      const errorMessage =
        response.statusCode == 422
          ? DaccachErrorActions().extractFormError(response.content)
          : response.content;
      throw DaccachErrorActions().createError(errorMessage);
    }

    return EventActions().deserializeClientEvent(response.content);
  },
};
